import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  orders: {
    startDate: null,
    endDate: null,
    types: [],
    locations: [],
    suppliers: [],
    venueSupplierSearch: [],
  },
  ordersByVenue: {},
  catalogue: {
    supplier: [],
  },
  supplierOrder: [],
}
const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      const { startDate, endDate, types, locations, suppliers } = action.payload
      state.orders = {
        startDate,
        endDate,
        types,
        locations,
        suppliers,
      }
    },

    saveVenueOrders: (state, { payload }) => {
      if (!state.ordersByVenue) state.ordersByVenue = {}
      state.ordersByVenue[payload.venueId] = payload.filter
    },

    setSpending: (state, action) => {
      state.supplierOrder = action.payload
    },

    setCatalouge: (state, action) => {
      state.catalogue = {
        supplier: [action.payload],
      }
    },

    resetOrders: (state, action) => {
      state.orders = { ...initialState.orders }
      if (action.payload && state.ordersByVenue)
        delete state.ordersByVenue[action.payload]
    },

    resetCatalouge: state => {
      state.catalogue.supplier = []
    },
  },
})

export const {
  resetOrders,
  setOrders,
  saveVenueOrders,
  setCatalouge,
  resetCatalouge,
  setSpending,
} = filterSlice.actions

export const setOrdersFilter = (filter, venueId) => dispatch => {
  if (venueId) dispatch(saveVenueOrders({ venueId, filter }))
  return dispatch(setOrders(filter))
}

export const resetOrdersFilter = venueId => dispatch =>
  dispatch(resetOrders(venueId))

export const setSupplierOrderFilter = filter => dispatch =>
  dispatch(setSpending(filter))

export const setCatalogueFilter = filter => dispatch =>
  dispatch(setCatalouge(filter))

export const resetCatalougeFilter = () => dispatch => dispatch(resetCatalouge())

export default filterSlice
